<template>
  <div class="form__field" :style="{ width: field.size }">
    <div class="form__title" v-show="field.title">{{ field.title }}</div>
    <div class="form__spacer" v-show="field.title"></div>
    <label class="form__label" v-show="field.label" :for="identifier">
      {{ field.label }}
    </label>
    <div class="form__control">
      <input
        class="form__input"
        type="password"
        v-model="value"
        :id="identifier"
        :name="identifier"
        @blur="validate()"
      />
    </div>
    <div
      class="form__message form__message--joined form__message--error"
      v-show="field.error"
    >
      {{ field.error }}
    </div>
    <div
      class="form__description"
      v-if="field.data && field.data.resetLink && field.data.resetText"
    >
      <a
        class="mod mod--style--normal mod--theme--primary mod--size--14 mod--weight--400"
        target="_blank"
        :href="field.data.resetLink"
      >
        {{ field.data.resetText }}
      </a>
    </div>
    <div class="form__description" v-show="field.description">
      {{ field.description }}
    </div>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-password"
};
</script>
